import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import { useGuidaUIStates } from '@inter-ikea-guida/framework';
import { SkapaText } from '@inter-ikea-guida/skapa';
import { getTranslation } from '../../store/i18n/selectors';
import { isMobile } from '../../utils';
import { Filter } from '../filter/Filter';
import { LayoutSelector } from './LayoutSelector';
import { StyledGuideHeading } from './styles';
export const FilterGuide = () => {
    const { isSidebarMode } = useGuidaUIStates();
    const translate = useSelector(getTranslation);
    return (_jsxs("div", { "data-testid": 'filter-guide', children: [isSidebarMode && (_jsx(StyledGuideHeading, { "$isFirstGuide": true, children: _jsx(SkapaText, { tagName: 'h2', textStyle: 'Heading.L', children: translate('guid01FwGuidingStep1') }) })), !isMobile() && _jsx(LayoutSelector, {}), _jsx(Filter, {})] }));
};
//# sourceMappingURL=FilterGuide.js.map